export default __webpack_public_path__ + "assets/imgs/logotipo_iac.8fd170d6.png";